function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { KeyGenerator, TokenScope } from "@superwall-me/schema";
import { MagicTeamUserId, allowedUsers } from "@superwall/constants";
import { randomUUID } from "crypto";
import * as faker from "faker";
import _, { sample } from "lodash";
import { nanoid } from "nanoid";
import db, { ApplicationPlatform, GlobalRole, MembershipRole } from "../db";
import { applicationWithoutIds } from "./application";
import { absoluteURL } from "./helpers";
import { organizationWithoutIds } from "./organization";
import { paywallWithoutIds } from "./paywall";
import { webPaywallWithoutIds } from "./webPaywall";
export * from "./application";
export * from "./helpers";
export * from "./organization";
export * from "./paywall";
export * from "./product";
export * from "./user";
export * from "./webPaywall";
const randomId = (max)=>{
    return Math.floor(Math.random() * max) + 1;
};
/*
 * This seed function is executed when you run `blitz db seed`.
 *
 */ const seedNewApp = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ SecurePassword }) {
        const email = "hello+newAcct@paywalrus.com";
        const password = "password1";
        yield db.user.create({
            data: {
                id: -1,
                name: "Wally the Baby Walrus",
                email: email.toLowerCase().trim(),
                hashedPassword: yield SecurePassword.hash(password),
                role: GlobalRole.CUSTOMER,
                memberships: {
                    create: {
                        role: MembershipRole.OWNER,
                        organization: {
                            create: {
                                id: -1,
                                name: `New Wally the Walrus's Organization`,
                                applications: {
                                    create: {
                                        id: -1,
                                        name: "Wally's New App",
                                        slug: "wally-new-app",
                                        revenueCatPublicAPIKey: "ZFZFYcjSDvgFZQvIVZFxSnNgBOAloffe",
                                        appId: "1234",
                                        publicApiKey: yield KeyGenerator.publicAPI(),
                                        appleUrlScheme: "fitnessai",
                                        featuresEnabled: "triggers,charts,users,notifications,localization,triggers_v2,editor_v4",
                                        paywalls: {
                                            create: [
                                                _object_spread({
                                                    id: -1
                                                }, paywallWithoutIds())
                                            ]
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    });
    return function seedNewApp(_) {
        return _ref.apply(this, arguments);
    };
}();
const productData = [
    {
        identifier: "com.fitnessai.annual_89.99_0",
        identifierRC: "annual_89.99_0",
        rawPrice: 89.99,
        trialPeriodDays: 0,
        period: "year"
    },
    {
        identifier: "com.fitnessai.annual_39.99_7",
        identifierRC: "annual_39.99_7",
        rawPrice: 39.99,
        trialPeriodDays: 7,
        period: "year"
    },
    {
        identifier: "com.fitnessai.annual_49.99_7",
        identifierRC: "annual_49.99_7",
        rawPrice: 49.99,
        trialPeriodDays: 7,
        period: "year"
    },
    {
        identifier: "com.fitnessai.monthly_14.99_7",
        identifierRC: "monthly_14.99_7",
        rawPrice: 14.99,
        trialPeriodDays: 7,
        period: "month"
    },
    {
        identifier: "com.fitnessai.annual_89.99_7",
        identifierRC: "annual_89.99_7",
        rawPrice: 89.99,
        trialPeriodDays: 7,
        period: "year"
    },
    {
        identifier: "com.fitnessai.weekly_4.99_3",
        identifierRC: "weekly_4.99_0",
        rawPrice: 4.99,
        trialPeriodDays: 3,
        period: "week"
    },
    {
        identifier: "com.fitnessai.weekly_2.99_0",
        identifierRC: "weekly_2.99_0",
        rawPrice: 2.99,
        trialPeriodDays: 0,
        period: "week"
    },
    {
        identifier: "com.fitnessai.weekly_3.99_0_3",
        identifierRC: "weekly_3.99_0",
        rawPrice: 3.99,
        trialPeriodDays: 0,
        period: "week"
    },
    {
        identifier: "com.fitnessai.monthly_12.49_7",
        identifierRC: "monthly_12.49_7",
        rawPrice: 12.49,
        trialPeriodDays: 7,
        period: "month"
    },
    {
        identifier: "com.fitnessai.annual_74.99_7",
        identifierRC: "annual_74.99_7",
        rawPrice: 74.99,
        trialPeriodDays: 7,
        period: "year"
    }
];
const globallyEnableFeatures = [
    "in_house_omniupload",
    "template_gallery",
    "element_background_image_styles",
    "product_settings",
    "page_styles",
    "remove_members",
    "rule_editor_v2",
    "duplicate_paywall",
    "paywall_preview_gallery",
    "surveys",
    "localization_integrations",
    "projects",
    "editor_v4",
    "localization_upload_download",
    "asa_client",
    "consumption_request",
    "save_snapshot_and_promote",
    "rule_entitlements"
];
const addGloballyEnableFeatures = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*() {
        yield db.globallyEnabledFeature.createMany({
            data: globallyEnableFeatures.map((feature)=>({
                    name: feature
                }))
        });
    });
    return function addGloballyEnableFeatures() {
        return _ref.apply(this, arguments);
    };
}();
const seed = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*({ SecurePassword }) {
        console.log(process.env.DATABASE_URL);
        // await db.$reset()
        console.log(`db`, db.$connect);
        const organizationsCount = 5;
        const applicationCount = 8;
        const maxPaywallsPerAcct = 5;
        const applicationUsersPerApp = 50;
        yield addGloballyEnableFeatures();
        // SEC: Insecure password seed
        const hashedPassword = yield SecurePassword.hash(nanoid());
        // Seed all the slack users so we can create a context that
        // will authenticate them
        const slackUsers = yield db.user.createMany({
            data: allowedUsers.map(({ email })=>({
                    email,
                    name: email.replace(/@.*/, ""),
                    hashedPassword,
                    role: GlobalRole.SUPERADMIN
                })),
            skipDuplicates: true
        });
        try {
            const teamAtUser = yield db.user.create({
                data: {
                    id: MagicTeamUserId,
                    email: "team@paywalrus.com",
                    name: "team@",
                    hashedPassword: yield SecurePassword.hash("password1"),
                    role: GlobalRole.CUSTOMER
                }
            });
            yield db.user.create({
                data: {
                    email: "admin@superwall.com",
                    name: "Superwall Admin",
                    hashedPassword: yield SecurePassword.hash("password1"),
                    role: GlobalRole.SUPERADMIN
                }
            });
            const orgs = yield Promise.all(Array.from(Array(organizationsCount).keys()).map(/*#__PURE__*/ function() {
                var _ref = _async_to_generator(function*(_) {
                    const orgStruct = organizationWithoutIds();
                    const org = yield db.organization.create({
                        data: orgStruct
                    });
                    yield db.membership.create({
                        data: {
                            role: MembershipRole.ADMIN,
                            organizationId: org.id,
                            userId: teamAtUser.id
                        }
                    });
                    return org;
                });
                return function(_) {
                    return _ref.apply(this, arguments);
                };
            }()));
            yield Promise.all(orgs.map(/*#__PURE__*/ function() {
                var _ref = _async_to_generator(function*(org) {
                    yield db.organizationLocalizationTarget.createMany({
                        data: [
                            "en",
                            "de",
                            "es",
                            "fr",
                            "hk",
                            "it",
                            "ja",
                            "ko"
                        ].map((locale)=>({
                                organizationId: org.id,
                                locale
                            }))
                    });
                });
                return function(org) {
                    return _ref.apply(this, arguments);
                };
            }()));
            const apps = yield Promise.all(Array.from(Array(applicationCount).keys()).map(/*#__PURE__*/ function() {
                var _ref = _async_to_generator(function*(i) {
                    var _sample;
                    const paywalls = Array.from(Array(randomId(maxPaywallsPerAcct)).keys()).map((_)=>paywallWithoutIds({
                            primaryProductIdentifier: productData[0].identifier
                        }));
                    const appStruct = yield applicationWithoutIds({
                        name: `${faker.company.companyName()}`
                    });
                    const assocOrgId = (_sample = sample(orgs)) === null || _sample === void 0 ? void 0 : _sample.id;
                    let localizationProviderId = undefined;
                    if (i === 2) {
                        let localizationProvider = yield db.localizationProvider.create({
                            data: {
                                type: "lokalise",
                                projectIdentifier: "8632418966ac0f6eeb37b0.18618281",
                                props: {
                                    apiKey: "4e5333d988bceaa82c06b84121fd16e560c729bb"
                                },
                                meta: {},
                                projectDisplayName: "Loaklise Project",
                                sourceLanguageDisplayName: "English",
                                sourceLanguageLocale: "en",
                                sourceLanguageProviderLanguageId: "640",
                                organizationId: assocOrgId,
                                visibilitySince: new Date()
                            }
                        });
                        localizationProviderId = localizationProvider.id;
                    }
                    const app = yield db.application.create({
                        // @ts-ignore
                        data: _object_spread(_object_spread_props(_object_spread(_object_spread_props(_object_spread({}, appStruct, i === 2 ? {
                            name: appStruct.name + " (WEB)"
                        } : {}, i === 2 ? {
                            publicApiKey: yield KeyGenerator.publicAPI("web_")
                        } : {}, i === 2 ? {
                            platform: ApplicationPlatform.WEB
                        } : {}), {
                            legacyPresentExperimentGroupId: undefined,
                            webhookDestinations: {
                                create: {
                                    enabled: true,
                                    authorizationToken: "abc",
                                    url: absoluteURL("/api/v1/test")
                                }
                            },
                            applicationAuthenticationTokens: {
                                create: {
                                    token: yield KeyGenerator.privateAPI(),
                                    scopes: [
                                        TokenScope.IntegrationsRevenueCat
                                    ]
                                }
                            },
                            paywalls: {
                                create: paywalls
                            }
                        }), i === 2 ? {
                            webPaywalls: {
                                create: webPaywallWithoutIds({})
                            }
                        } : {}), {
                            organization: {
                                connect: {
                                    id: assocOrgId
                                }
                            }
                        }), typeof localizationProviderId != "undefined" ? {
                            localizationProvider: {
                                connect: {
                                    id: localizationProviderId
                                }
                            }
                        } : {})
                    });
                    // if (app.platform === ApplicationPlatform.WEB) {
                    //   // Try to write the pk.json file to the examples directory
                    //   try {
                    //     const pkFile = path.join(
                    //       __dirname,
                    //       "..",
                    //       "..",
                    //       "..",
                    //       "examples",
                    //       "superwall-web-example",
                    //       "src",
                    //       "pk.json"
                    //     )
                    //     fs.writeFileSync(
                    //       pkFile,
                    //       JSON.stringify({
                    //         pk: app.publicApiKey,
                    //       })
                    //     )
                    //   } catch (e) {
                    //     console.error(e)
                    //   }
                    // }
                    const applicationId = app.id;
                    // const { Decimal } = await import("@prisma/client/runtime")
                    // await db.product.createMany({
                    //   data: productData.map(({ rawPrice, ...prod }) =>
                    //     productWithoutIds({
                    //       rawPrice: new Decimal(rawPrice), // Fix: Convert rawPrice to Decimal
                    //       ...prod,
                    //       applicationId,
                    //     })
                    //   ),
                    // })
                    const createdPaywalls = yield db.paywall.findMany({
                        where: {
                            applicationId: app.id
                        }
                    });
                    const applicationUser = Array.from(Array(randomId(applicationUsersPerApp)).keys()).map(()=>({
                            applicationId: app.id,
                            paywallId: _.sample(createdPaywalls).id,
                            properties: {
                                age: 48,
                                sex: "male",
                                email: "jamie.hiltonepps@gmail.com",
                                $email: "jamie.hiltonepps@gmail.com",
                                routine: "Custom",
                                gym_name: "",
                                hiit_mode: false,
                                objective: "strength_training",
                                referrals: 0,
                                back_ratio: 1,
                                first_name: "Jamie",
                                legs_ratio: 1,
                                randomness: 0.35,
                                toned_mode: false,
                                weeklyGoal: 4,
                                $apns_token: "7962C4B433E1C0C81E25762D4BE1A870BCF5C0574E0DD19617C923B812753F6D",
                                $created_at: "2020-08-19T14:31:55.668Z",
                                $first_name: "Jamie",
                                chest_ratio: 1,
                                days_logged: 137,
                                free_access: false,
                                free_passes: 0,
                                paying_user: true,
                                sets_logged: 2066,
                                audio_queues: false,
                                beta_enabled: true,
                                friends_count: 0,
                                height_metric: 183,
                                weight_metric: 104.5,
                                followers_count: 0,
                                following_count: 0,
                                height_imperial: 72,
                                is_app_unlocked: true,
                                shoulders_ratio: 1,
                                weight_imperial: 230,
                                defaultEquipment: "",
                                did_see_waitlist: false,
                                gym_pass_barcode: "",
                                maintenance_mode: false,
                                auto_show_log_set: true,
                                completed_sign_up: true,
                                delay_free_passes: 0,
                                enabledPushNotifs: true,
                                uses_metric_units: false,
                                waitlist_position: 0,
                                $is_standard_event: false,
                                is_app_under_review: true,
                                prefers_higher_reps: true,
                                sync_with_health_kit: true,
                                total_branch_credits: 0,
                                free_passes_remaining: 0,
                                feed_should_show_music: true,
                                is_rest_timer_disabled: false,
                                prefers_compact_layout: false,
                                eligible_for_free_trial: false,
                                max_preferred_rest_time: 120,
                                min_preferred_rest_time: 120,
                                startingExperienceLevel: "intermediate",
                                location_based_equipment: true,
                                waitlist_friends_invited: 0,
                                $application_installed_at: "2020-08-18T22:09:07.721Z",
                                can_share_for_free_passes: true,
                                feed_should_show_gym_pass: true,
                                prefers_longer_rest_times: false,
                                preferred_workout_duration: 5,
                                feed_should_show_ab_routine: true,
                                feed_should_show_apple_health: true,
                                feed_should_show_cardio_timer: true
                            }
                        }));
                    yield db.applicationUser.createMany({
                        data: applicationUser
                    });
                    const applicationUsers = yield db.applicationUser.findMany({
                        where: {
                            applicationId: app.id
                        }
                    });
                    yield db.applicationUserAlias.createMany({
                        data: applicationUsers.map((au)=>{
                            return {
                                applicationId: app.id,
                                applicationUserId: au.id,
                                appUserId: `$SuperwallAlias:${randomUUID()}`
                            };
                        })
                    });
                    const paywallPreviewSeed = createdPaywalls.map((paywall)=>({
                            active: true,
                            url: "https://paywall-screenshots.superwall.com/q3xdXCi0cIUhAB8b0eVoe.png",
                            paywallId: paywall.id,
                            identifier: `${randomUUID()}`
                        }));
                    yield db.paywallPreview.createMany({
                        data: paywallPreviewSeed
                    });
                    return app;
                });
                return function(i) {
                    return _ref.apply(this, arguments);
                };
            }()));
            yield seedNewApp({
                SecurePassword
            });
            yield db.user.create({
                data: {
                    email: "hello+singleOrg@paywalrus.com".toLowerCase().trim(),
                    name: "John Doe",
                    hashedPassword: yield SecurePassword.hash("password1"),
                    role: GlobalRole.CUSTOMER,
                    memberships: {
                        create: {
                            role: MembershipRole.ADMIN,
                            organizationId: 1
                        }
                    }
                }
            });
            const typicalUser = yield db.user.create({
                data: {
                    email: "hello@paywalrus.com".toLowerCase().trim(),
                    name: "Wally the Walrus",
                    hashedPassword: yield SecurePassword.hash("password1"),
                    role: GlobalRole.CUSTOMER
                }
            });
            yield db.membership.createMany({
                data: _.sampleSize(orgs, 3).map((o)=>({
                        role: MembershipRole.ADMIN,
                        organizationId: o.id,
                        userId: typicalUser.id
                    }))
            });
        // Uncomment if you need to seed clickhouse along with mysql
        // await seedClickhouse("all")
        } catch (e) {
            console.log(e);
            console.log(Error("Error Seeding Database"));
        }
        // Seed bot user
        yield db.botUser.create({
            data: {
                name: "local-playwright",
                authorizedSOAs: [
                    {
                        kind: "application",
                        action: "read",
                        object: {
                            applicationId: -1
                        }
                    }
                ],
                accessToken: "local-playwright",
                user: {
                    create: {
                        email: "bot-user@superwall.com",
                        name: "bot-user"
                    }
                }
            }
        });
    });
    return function seed(_) {
        return _ref.apply(this, arguments);
    };
}();
export default seed;
